import { HStack, Image, VStack, Text } from "@chakra-ui/react";
import { LINKS } from "lib/utils/constants";
import { useTranslations } from "next-intl";

export default function Footer() {
  const t = useTranslations("components.navbar");
  // eslint-disable-next-line i18next/no-literal-string
  const cofinancersLogos: (keyof typeof LINKS["images"])[] = ["prr", "republicPt", "europeanUnion"];
  
  return (
    <HStack align="start" p={8} gap={12} justify="center">
      <VStack gap={6} justify="end" height="100%">
        <Image
          h="80px"
          alt="myHeart logo"
          src={LINKS.images.bigLogo}
          filter={"grayscale(100%)"}
        />
      </VStack>

      <VStack gap={6} align="start">
        <Text
          mt="2"
          fontSize="2xs"
          fontWeight="bold"
          textAlign="center"
        >
          {t("createdByBeapt")}
        </Text>
        <HStack>
          <Image
            w="160px"
            alt="armando teixeira logo"
            src={LINKS.images.armandoTeixeiraLogo}
            filter={"grayscale(100%)"}
          />
          <Image
            w="80%"
            maxW="200px"
            alt="strava logo"
            src={LINKS.images.poweredByStrava}
            filter={"grayscale(100%)"}
          />
        </HStack>
      </VStack>
      <VStack gap={10} align="start">
        <Text
          mt="2"
          fontSize="2xs"
          fontWeight="bold"
          textAlign="center"
        >
          {t("coFinancedBy")}
        </Text>
        <HStack>
          {
            cofinancersLogos.map((logo: keyof typeof LINKS["images"], index: number) => (
              <Image
                key={index}
                w="160px"
                alt={logo}
                src={LINKS.images[logo] as string}
                filter={"grayscale(100%)"}
              />))
          }
        </HStack>
      </VStack>
    </HStack>
  );
}